import { render } from "./tree-menu-accent.vue?vue&type=template&id=ad2e4d7d"
const script = {  }

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__